module.exports = __webpack_public_path__ + "img/max_deposit_ntd_desktop.fd61e5d5.png";